import { Suspense } from "react";
import { LoadingScreen } from "@/components/LoadingScreen";
import AppRouter from "@/AppRouter";

export default function App() {
  return (
    <Suspense fallback={<LoadingScreen isLoading />}>
      <AppRouter />
    </Suspense>
  );
}
